import { data } from '../../svg/ArrowUp/data';
import { makeIcon } from '../makeIcon';

export const ArrowUp = makeIcon(data, 'arrow_upward', 'ArrowUp');

export default ArrowUp;
